import { Copy, Dialog, DialogProps } from '@highmobility/console-ui-components';

import { copyTextToClipboard } from '@/services/textFileService';

export type CertificateSnippetDialogProps = {
  isOpen: DialogProps['isOpen'];
  setIsOpen: DialogProps['setIsOpen'];
  snippet: string; // mosquitto_sub --host ...
};

export function CertificateSnippetDialog(props: CertificateSnippetDialogProps) {
  const command = props.snippet.slice(0, props.snippet.indexOf(' ')).trim();
  const args = props.snippet.slice(props.snippet.indexOf(' ')).trim();

  const onClickCopy = () => copyTextToClipboard(`${command} ${args}`);

  return (
    <Dialog isOpen={props.isOpen} setIsOpen={props.setIsOpen} title="Snippet" flexWidth>
      <div className="flex gap-3" aria-label="Snippet">
        <div>{command}</div>
        <div
          className="whitespace-pre"
          dangerouslySetInnerHTML={{
            __html: args,
          }}
        />
        <div aria-label="Copy snippet" onClick={onClickCopy}>
          <Copy className="ml-auto h-4 w-4 flex-shrink-0 cursor-pointer text-white-60 transition-colors hover:text-white-80" />
        </div>
      </div>
    </Dialog>
  );
}
